import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Styles/border-right-style";
import * as React from 'react';
export default {
  Content,
  React
};